import { lazy } from 'react';
import Loadable from '../../layouts/full-layout/loadable/Loadable';

export const FullLayout = Loadable(lazy(() => import('../../layouts/full-layout/FullLayout')));
